export default __webpack_public_path__ + "static/media/MicrosoftTeams-image-375X550.ead9ff17.png";